export const BONUS_SHOP_NEW_UNTIL = '2026-11-27T00:00:00Z';

export const LOOTBOX_EXCHANGE_ENABLED = false;
